import { generatePath, matchPath } from 'react-router';

export class EnhancedPath {
  constructor(path) {
    this._path = path;
  }

  get path() {
    return this._path;
  }

  generatePath(params) {
    return generatePath(this.path, params);
  }

  matchPath(pathname, params) {
    return matchPath(pathname, { ...params, path: this.path });
  }

  navigateWith(historyMethod, params, locationDescriptor) {
    return historyMethod({ pathname: this.generatePath(params), ...locationDescriptor });
  }
}
